import { APP_NAV, type AppNavItem } from "@/app/routes";

export function documentTitle(brand: string, module?: string): string {
	const name = module?.trim();
	return name ? `${brand}: ${name}` : brand;
}

export function navMatchForPath(
	pathname: string,
	items: AppNavItem[] = APP_NAV,
): { item: AppNavItem; parent?: AppNavItem } | null {
	const normalized = pathname.replace(/\/+$/, "") || "/";

	for (const item of items) {
		if (item.children?.length) {
			const child = navMatchForPath(normalized, item.children);
			if (child) {
				return { item: child.item, parent: item };
			}
		}
		if (normalized === item.path || normalized.startsWith(`${item.path}/`)) {
			return { item };
		}
	}

	return null;
}

export function moduleLabelForPath(
	pathname: string,
	t: (key: string) => string,
): string | undefined {
	if (pathname === "/login") {
		return t("login.module");
	}
	const match = navMatchForPath(pathname);
	if (!match) {
		return undefined;
	}
	const leaf = t(match.item.labelKey);
	if (!match.parent) {
		return leaf;
	}
	return `${t(match.parent.labelKey)} — ${leaf}`;
}
